import { Grid, Input, Span } from 'components'
import { useMovement } from 'hooks'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

const DadosEfetivo = () => {
  const { movState } = useMovement()

  return (
    <>
      <Span
        marginTop={SPACING.spacing20}
        marginBottom={SPACING.spacing20}
        text="DADOS DO EFETIVO"
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
        color={COLORS.black}
      />
      <Grid
        gridCols="1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr"
        gridGap="1rem"
        padding={`0 0 ${SPACING.spacing30}`}
      >
        <Input
          value={movState?.visaoTotal?.qtAtivo}
          label="Ativo"
          placeholder="Ativo"
          formValue="qtAtivo"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtDemitido}
          label="Demitido"
          placeholder="Demitido"
          formValue="qtDemitido"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtAcesso}
          label="Acesso"
          placeholder="Acesso"
          formValue="qtAcesso"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtTransferido}
          label="Transferido"
          placeholder="Transferido"
          formValue="qtTransferido"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtAfastado}
          label="Afastado"
          placeholder="Afastado"
          formValue="qtAfastado"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtCompartilhado}
          label="Compartilhado"
          placeholder="Compartilhado"
          formValue="qtCompartilhado"
          disabled
        />
        <Input
          value={(movState?.visaoTotal?.qtAtivo + movState?.visaoTotal?.qtDemitido)}
          label="Total Efetivo"
          placeholder="Total Efetivo"
          formValue="qtTotalEfetivo"
          disabled
        />
      </Grid>
    </>
  )
}

export default DadosEfetivo
